import { pushEvent } from '../../../client/data-layer';

type Filters = {
  offset?: number | null;
  orderBy?: string | null;
};

type Sort = string | undefined | null;

export const productReviewsListed = (orderBy: Sort, filters: Filters) => {
  pushEvent('productReviewsListed', { orderBy, filters });
};

export const storeReviewsListed = (orderBy: Sort, filters: Filters) => {
  pushEvent('storeReviewsListed', { orderBy, filters });
};

export const productReviewCreated = () => {
  pushEvent('productReviewCreated');
};

export const storeReviewCreated = () => {
  pushEvent('storeReviewCreated');
};

export const productRated = (rating: number) => {
  pushEvent('productRated', { rating });
};

export const storeRated = (rating: number) => {
  pushEvent('storeRated', { rating });
};

export const productReviewEdited = () => {
  pushEvent('productReviewEdited');
};

export const storeReviewEdited = () => {
  pushEvent('storeReviewEdited');
};

export const productReviewDeleted = () => {
  pushEvent('productReviewDeleted');
};

export const storeReviewDeleted = () => {
  pushEvent('storeReviewDeleted');
};

export const productReviewReported = () => {
  pushEvent('productReviewReported');
};

export const storeReviewReported = () => {
  pushEvent('storeReviewReported');
};

export const productReviewViewed = () => {
  pushEvent('productReviewViewed');
};

export const storeReviewViewed = () => {
  pushEvent('storeReviewViewed');
};
